@if(!isOnHome){
    <div class="page-title-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="page-title-content text-white">
                        <h2>Häufig gestellte Fragen</h2>
                        <ul class="text-gray-200">
                            <li><a routerLink="/" class="hover:underline">Home</a></li>
                            <li>Häufig gestellte Fragen</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
<div class="container py-5">
    <div class="section-title">
        @if(isOnHome){
            <h2>Häufig gestellte Fragen</h2>
            <div class="bar"></div>
        }
        <p>Hier findest du Antworten auf die häufigsten Fragen rund um HIGETO e.V., unsere Projekte und deine Möglichkeiten zur Unterstützung.</p>
    </div>

    <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
            <div class="faq-accordion-content">
                <div class="accordion" id="faqAccordion">
                    <!-- Frage 1 -->
                    <div class="card">
                        <div class="card-header" id="headingOne">
                            <button type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Wer kann Mitglied bei HIGETO e.V. werden?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseOne" class="collapse show" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Jede Person, die unsere Ziele unterstützt, kann Mitglied werden. Der Mitgliedsbeitrag beträgt nur 20 € im Jahr.</p>
                            </div>
                        </div>
                    </div>

                    <!-- Frage 2 -->
                    <div class="card">
                        <div class="card-header" id="headingTwo">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Wie kann ich aktiv helfen?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseTwo" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Du kannst HIGETO e.V. aktiv unterstützen – z. B. durch ehrenamtliches Engagement, Spenden, Projektarbeit oder Öffentlichkeitsarbeit.</p>
                            </div>
                        </div>
                    </div>

                    <!-- Frage 3 -->
                    <div class="card">
                        <div class="card-header" id="headingThree">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Wie werden die Spenden verwendet?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseThree" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Unsere Spenden fließen direkt in Projekte vor Ort – wie den Bau von Brunnen, Gesundheitseinrichtungen und Schulen. Wir arbeiten transparent und effizient.</p>
                            </div>
                        </div>
                    </div>

                    <!-- Frage 4 -->
                    <div class="card">
                        <div class="card-header" id="headingFour">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                Wie kann ich Mitglied werden?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseFour" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Fülle einfach den Mitgliedsantrag aus und sende ihn an <a href="mailto:hgesundheit.togo@gmail.com">hgesundheit.togo&commat;gmail.com</a>. Das Formular findest du auf unserer Website.</p>
                            </div>
                        </div>
                    </div>

                    <!-- Frage 5 -->
                    <div class="card">
                        <div class="card-header" id="headingFive">
                            <button class="collapsed"Ï type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                Was macht HIGETO e.V. konkret?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseFive" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Wir setzen uns für Gesundheit, Bildung und Trinkwasser in Togo ein – durch den Bau von Brunnen, Schulen, Gesundheitszentren und mit Bildungs- und Präventionsprogrammen.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bild -->
        <div class="col-lg-6 col-md-12">
            <div class="faq-image">
                <img src="assets/img/faq-higeto.png" alt="FAQ Bild" class="img-fluid rounded">
            </div>
        </div>
    </div>
</div>
@if(!isOnHome){
    <app-subscribe></app-subscribe>
}
